import React from "react";
import ReactDOM from "react-dom/client";
import MyApp from "./MyApp";
import { BrowserRouter } from "react-router-dom";
import "./index.css";

import { Provider } from "react-redux";
import { PersistGate } from "redux-persist/integration/react";
import { store, persistor } from "./store";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <Provider store={store}>
    <PersistGate loading={null} persistor={persistor}>
      <BrowserRouter>
        <MyApp />
      </BrowserRouter>
    </PersistGate>
  </Provider>
);
